import {
  GET_ANALYTICS_DATA,
  LOAD_MORE_ANALYTICS_DATA,
  SEARCH_ANALYTICS_DATA,
} from "../types";

import { firebase } from "../../../firebase/initFirebase";

import { store } from "../../store";
import { message } from "antd";

export const getAnalyticsData = (props) => {
  return async (dispatch) => {
    console.log("hi");
    var reduxState = store.getState();

    var userLocation = reduxState.auth.user.branch;
    var Firestore = firebase.firestore();
    var dataRef = Firestore.collection(props.apiurl);
    // console.log(props)

    if (props.use_sale_date) {
      dataRef = dataRef.orderBy("sale_date", "desc");
      dataRef = dataRef.where("sale_date", ">=", props.start_date);
      dataRef = dataRef.where("sale_date", "<=", props.end_date);
    } else if (props.use_wasted_date) {
      dataRef = dataRef.orderBy("wasted_date", "desc");
      dataRef = dataRef.where("wasted_date", ">=", props.start_date);
      dataRef = dataRef.where("wasted_date", "<=", props.end_date);
    } else {
      dataRef = dataRef.orderBy("created_at", "desc");
      dataRef = dataRef.where("created_at", ">=", props.start_date);
      dataRef = dataRef.where("created_at", "<=", props.end_date);
    }

    if (props.packageStatus) {
      dataRef = dataRef.where("status", "==", props.packageStatus);
    }

    var documentSnapshots = await dataRef.get();
    var docs = documentSnapshots.docs;
    var lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];
    var dataArray = [];
    if (props.apiurl == "packages") {
      await Promise.all(
        docs.map(async (packageItem) => {
          var newOrder = {
            key: packageItem.id,
            id: packageItem.id,
            ...packageItem.data(),
          };

          var dataRefItems = Firestore.collection("packages")
            .doc(packageItem.id)
            .collection("items");
          var documentSnapshots2 = await dataRefItems.get();
          var docs2 = documentSnapshots2.docs;
          var newItems = [];

          await Promise.all(
            docs2.map(async (item) => {
              var bago = {
                key: item.id,
                id: item.id,
                ...item.data(),
              };
              if (bago.product) {
                var itemref = Firestore.collection("products").doc(
                  bago.product
                );
                var newd = await itemref.get();
                if (newd.data()) {
                  var data3 = newd.data();
                  var localavailable = 0;
                  if (data3[`${userLocation}_count`]) {
                    localavailable = data3[`${userLocation}_count`];
                  }
                  bago["location_available"] = localavailable;
                  // bago['regionalization'] = data3.regionalization
                }
              }
              newItems.push(bago);
            })
          );
          newOrder["items"] = newItems;

          dataArray.push(newOrder);
        })
      );
    } else {
      docs.map((packageItem) => {
        console.log(packageItem);
        var newOrder = {
          key: packageItem.id,
          id: packageItem.id,
          ...packageItem.data(),
        };
        dataArray.push(newOrder);
      });
    }

    dispatch({
      type: GET_ANALYTICS_DATA,
      payload: {
        dataArray: dataArray,
        lastVisible: lastVisible,
        currentProps: props,
      },
    });
    console.log("hi2");
  };
};

export const getAnalyticsData2 = (props) => {
  return async (dispatch) => {
    console.log("Fetching analytics data...");

    const reduxState = store.getState();
    const userLocation = reduxState.auth.user.branch;
    const Firestore = firebase.firestore();
    let dataRef = Firestore.collection(props.apiurl);
    const batchSize = 50; // Adjust batch size as needed

    // Apply filters based on date type
    if (props.use_sale_date) {
      dataRef = dataRef
        .orderBy("sale_date", "desc")
        .where("sale_date", ">=", props.start_date)
        .where("sale_date", "<=", props.end_date);
    } else if (props.use_wasted_date) {
      dataRef = dataRef
        .orderBy("wasted_date", "desc")
        .where("wasted_date", ">=", props.start_date)
        .where("wasted_date", "<=", props.end_date);
    } else {
      dataRef = dataRef
        .orderBy("created_at", "desc")
        .where("created_at", ">=", props.start_date)
        .where("created_at", "<=", props.end_date);
    }

    // Apply additional filters
    if (props.packageStatus) {
      dataRef = dataRef.where("status", "==", props.packageStatus);
    }

    let lastVisible = null;
    let hasMoreData = true;
    let allData = [];

    while (hasMoreData) {
      let query = lastVisible
        ? dataRef.startAfter(lastVisible).limit(batchSize)
        : dataRef.limit(batchSize);
      let documentSnapshots = await query.get();

      if (documentSnapshots.empty) {
        hasMoreData = false;
        break;
      }

      lastVisible = documentSnapshots.docs[documentSnapshots.docs.length - 1];

      let batchData = [];
      let fetchItemsPromises = [];

      for (let packageItem of documentSnapshots.docs) {
        let newOrder = {
          key: packageItem.id,
          id: packageItem.id,
          ...packageItem.data(),
        };

        if (props.apiurl === "packages") {
          let dataRefItems = Firestore.collection("packages")
            .doc(packageItem.id)
            .collection("items");
          fetchItemsPromises.push(
            dataRefItems.get().then(async (documentSnapshots2) => {
              let newItems = await Promise.all(
                documentSnapshots2.docs.map(async (item) => {
                  let bago = {
                    key: item.id,
                    id: item.id,
                    ...item.data(),
                  };

                  if (bago.product) {
                    let itemref = Firestore.collection("products").doc(
                      bago.product
                    );
                    let newd = await itemref.get();
                    if (newd.exists) {
                      let data3 = newd.data();
                      bago["location_available"] =
                        data3[`${userLocation}_count`] || 0;
                    }
                  }
                  return bago;
                })
              );
              newOrder["items"] = newItems;
            })
          );
        }

        batchData.push(newOrder);
      }

      await Promise.all(fetchItemsPromises);

      // Add batch data to allData
      allData = [...allData, ...batchData];

      // Dispatch batch update
      dispatch({
        type: GET_ANALYTICS_DATA,
        payload: {
          dataArray: allData,
          lastVisible,
          currentProps: props,
        },
      });
    }

    console.log("Fetching complete.");
  };
};

export const loadMoreAnalyticsData = () => {
  return async (dispatch) => {
    var reduxState = store.getState();
    var userRole = reduxState.auth.user.role;

    var currentLastItem = reduxState.packages.lastVisible;
    var userLocation = reduxState.auth.user.branch;
    var currentProps = reduxState.packages.currentProps;
    var Firestore = firebase.firestore();

    var dataRef = Firestore.collection(currentProps.apiurl);

    if (currentProps.use_sale_date) {
      dataRef = dataRef.orderBy("sale_date", "desc");
    } else {
      dataRef = dataRef.orderBy("created_at", "desc");
    }

    if (currentProps.packageStatus) {
      dataRef = dataRef.where("status", "==", currentProps.packageStatus);
    }

    if (
      userRole !== "admin" &&
      userRole !== "warehouse" &&
      userRole !== "manager"
    ) {
      dataRef = dataRef.where("destination", "==", userLocation);
    }

    if (currentLastItem) {
      dataRef = dataRef.startAfter(currentLastItem);

      if (currentProps.searchText) {
        dataRef = dataRef
          .where("name", ">=", currentProps.searchText)
          .where("name", "<=", currentProps.searchText + "\uf8ff");
      }

      dataRef = dataRef.limit(100);

      var documentSnapshots = await dataRef.get();
      var docs = documentSnapshots.docs;
      if (docs) {
        var lastVisible =
          documentSnapshots.docs[documentSnapshots.docs.length - 1];
        var dataArray = [];
        if (currentProps.apiurl == "packages") {
          await Promise.all(
            docs.map(async (packageItem) => {
              var newOrder = {
                key: packageItem.id,
                id: packageItem.id,
                ...packageItem.data(),
              };
              var dataRefItems = Firestore.collection("packages")
                .doc(packageItem.id)
                .collection("items");
              var documentSnapshots2 = await dataRefItems.get();
              var docs2 = documentSnapshots2.docs;
              var newItems = [];

              await Promise.all(
                docs2.map(async (item) => {
                  var bago = {
                    key: item.id,
                    id: item.id,
                    ...item.data(),
                  };
                  if (bago.product) {
                    var itemref = Firestore.collection("products").doc(
                      bago.product
                    );
                    var newd = await itemref.get();
                    if (newd.data()) {
                      var data3 = newd.data();
                      var localavailable = 0;
                      if (data3[`${userLocation}_count`]) {
                        localavailable = data3[`${userLocation}_count`];
                      }
                      bago["location_available"] = localavailable;
                      bago["regionalization"] = data3.regionalization;
                    }
                  }
                  newItems.push(bago);
                })
              );
              newOrder["items"] = newItems;

              dataArray.push(newOrder);
            })
          );
        } else {
          docs.map((packageItem) => {
            var newOrder = {
              key: packageItem.id,
              id: packageItem.id,
              ...packageItem.data(),
            };
            dataArray.push(newOrder);
          });
        }
        if (lastVisible && currentLastItem !== lastVisible) {
          dispatch({
            type: LOAD_MORE_ANALYTICS_DATA,
            payload: { dataArray: dataArray, lastVisible: lastVisible },
          });
        } else {
          message.error("No More Orders To Load");
        }
      } else {
        message.error("No More Orders To Load");
      }
    }
  };
};

export const searchPackageData = (filter, data) => {
  return (dispatch) => {
    dispatch({
      type: SEARCH_ANALYTICS_DATA,
      filter: filter,
      data: data,
    });
  };
};
